export default function setNodeNameChange(
  nodeName,
  openDrawer,
  setBladeSide,
  setDrawerCategory,
) {
  // Based on nodeNames from Threekit
  switch (nodeName) {
    case 'artbox_front':
      openDrawer('Blade');
      setBladeSide('Front');
      break;
    case 'artbox_back':
      openDrawer('Blade');
      setBladeSide('Back');
      break;
    case 'artbox_droppoint_front':
      openDrawer('Blade');
      setBladeSide('Front');
      break;
    case 'artbox_droppoint_back':
      openDrawer('Blade');
      setBladeSide('Back');
      break;
    case 'artbox_droppoint_serrated_front':
      openDrawer('Blade');
      setBladeSide('Front');
      break;
    case 'artbox_droppoint_serrated_back':
      openDrawer('Blade');
      setBladeSide('Back');
      break;
    case 'blade':
      openDrawer('Blade');
      break;
    case 'blade_front':
      openDrawer('Blade');
      setBladeSide('Front');
      break;
    case 'blade_front_transparent':
      openDrawer('Blade');
      setBladeSide('Front');
      break;
    case 'blade_back':
      openDrawer('Blade');
      setBladeSide('Back');
      break;
    case 'blade_back_transparent':
      openDrawer('Blade');
      setBladeSide('Back');
      break;
    case 'handle_notched':
      openDrawer('Handle');
      setDrawerCategory('Color & Material');
      break;
    case 'handle':
      openDrawer('Handle');
      setDrawerCategory('Color & Material');
      setBladeSide('Front');
      break;
    case 'handle_notched_bolster':
      openDrawer('Handle');
      setDrawerCategory('Bolster');
      break;
    case 'handle_front':
      openDrawer('Handle');
      setDrawerCategory('Color & Material');
      setBladeSide('Front');
      break;
    case 'handle_carbon_front':
      openDrawer('Handle');
      setDrawerCategory('Color & Material');
      setBladeSide('Front');
      break;
    case 'handle_back':
      openDrawer('Handle');
      setDrawerCategory('Color & Material');
      setBladeSide('Back');
      break;
    case 'handle_carbon_back':
      openDrawer('Handle');
      setDrawerCategory('Color & Material');
      setBladeSide('Back');
      break;
    case 'handle_g10_front':
      openDrawer('Handle');
      setDrawerCategory('Color & Material');
      setBladeSide('Front');
      break;
    case 'handle_g10_back':
      openDrawer('Handle');
      setDrawerCategory('Color & Material');
      setBladeSide('Back');
      break;
    case 'handle_carbon_fiber_front':
      openDrawer('Handle');
      setBladeSide('Front');
      break;
    case 'handle_glass_filled_nylon_front':
      openDrawer('Handle');
      setBladeSide('Front');
      break;
    case 'handle_carbon_fiber_back':
      openDrawer('Handle');
      setBladeSide('Back');
      break;
    case 'handle_glass_filled_nylon_back':
      openDrawer('Handle');
      setBladeSide('Back');
      break;
    case 'g10_handle_front':
      openDrawer('Handle');
      setDrawerCategory('Color & Material');
      setBladeSide('Front');
      break;
    case 'g10_handle_back':
      openDrawer('Handle');
      setDrawerCategory('Color & Material');
      setBladeSide('Back');
      break;
    case 'bolster':
      openDrawer('Handle');
      setDrawerCategory('Bolster');
      break;
    case 'bolster_front':
      openDrawer('Handle');
      setDrawerCategory('Bolster');
      setBladeSide('Front');
      break;
    case 'bolster_back':
      openDrawer('Handle');
      setDrawerCategory('Bolster');
      setBladeSide('Back');
      break;
    case 'pivot_ring_inner':
      openDrawer('Handle');
      setDrawerCategory('Pivot Ring');
      break;
    case 'pivot_ring_outer':
      openDrawer('Handle');
      setDrawerCategory('Pivot Ring');
      break;
    case 'pivot_ring_front':
      openDrawer('Handle');
      setDrawerCategory('Pivot Ring');
      setBladeSide('Front');
      break;
    case 'pivot_ring_back':
      openDrawer('Handle');
      setDrawerCategory('Pivot Ring');
      setBladeSide('Back');
      break;
    case 'pivot_collar':
      openDrawer('Hardware');
      setDrawerCategory('Pivot Collar');
      break;
    case 'hardware_inner':
      openDrawer('Handle');
      break;
    case 'axis_front':
      openDrawer('Hardware');
      setDrawerCategory('Axis');
      setBladeSide('Front');
      break;
    case 'axis_back':
      openDrawer('Hardware');
      setDrawerCategory('Axis');
      setBladeSide('Back');
      break;
    case 'bolts':
      openDrawer('Hardware');
      setDrawerCategory('Screws');
      break;
    case 'screws_front':
      openDrawer('Hardware');
      setDrawerCategory('Screws');
      setBladeSide('Front');
      break;
    case 'screws_back':
      openDrawer('Hardware');
      setDrawerCategory('Screws');
      setBladeSide('Back');
      break;
    case 'main_screw_front':
      openDrawer('Hardware');
      setDrawerCategory('Screws');
      setBladeSide('Front');
      break;
    case 'main_screw_back':
      openDrawer('Hardware');
      setDrawerCategory('Screws');
      setBladeSide('Back');
      break;
    case 'anodized_thumb_lug':
      openDrawer('Hardware');
      setDrawerCategory('Spacers & Thumb Lug');
      setBladeSide('Front');
      break;
    case 'anodized_thumb_lug_back':
      openDrawer('Hardware');
      setDrawerCategory('Spacers & Thumb Lug');
      setBladeSide('Back');
      break;
    case 'anodized_thumb_lug_front':
      openDrawer('Hardware');
      setDrawerCategory('Spacers & Thumb Lug');
      setBladeSide('Front');
      break;
    case 'liner':
      openDrawer('Handle');
      setDrawerCategory('Liner');
      break;
    case 'backspacer':
      openDrawer('Hardware');
      setDrawerCategory('Backspacer');
      break;
    case 'log_front':
      openDrawer('Blade');
      setBladeSide('Front');
      break;
    case 'log_back':
      openDrawer('Blade');
      setBladeSide('Back');
      break;
    case 'main_bolt_transpater_front':
      openDrawer('Hardware');
      setDrawerCategory('Screws');
      setBladeSide('Front');
      break;
    case 'main_bolt_transpater_back':
      openDrawer('Hardware');
      setDrawerCategory('Screws');
      setBladeSide('Back');
      break;
    default:
      break;
  }

  // Helps with clip variations since there are
  // alot of them, but luckily they all start with 'clip'
  if (nodeName.startsWith('clip')) {
    openDrawer('Hardware');
    setDrawerCategory('Clip');
    setBladeSide('Back');
  }
}
